import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextBox from 'UI/components/atoms/TextBox';

export const ActionButtonContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(0, 1, 2, 0),
  display: 'flex',
  alignItems: 'center'
}));

export const AttachmentChip = styled(Chip)(({ theme }) => ({
  height: '36px',
  padding: theme.spacing(1, 1.5),
  borderRadius: '8px',
  backgroundColor: theme.palette.grey[200],
  maxWidth: '380px',
  display: 'flex',

  '& .MuiChip-label': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%'
  },

  '& .MuiChip-icon': {
    color: theme.palette.grey[600]
  },

  '& .MuiChip-deleteIcon': {
    color: theme.palette.grey[800]
  }
}));

export const ComposerContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1, 2, 2),
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1
}));

export const FlexBetweenRow = styled('div')({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between'
});

export const MessageInputWrapper = styled('div')({
  flexGrow: 1,
  position: 'relative'
});

export const MessageInput = styled(TextBox)(({ theme }) => ({
  flexGrow: 1,
  '& > div': {
    '& > textarea': {
      width: '100%',
      paddingRight: theme.spacing(6)
    }
  }
}));

export const CharCounterTypography = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(3.5),
  right: theme.spacing(1)
}));

export const ExceededTypography = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  left: theme.spacing(1.5),
  bottom: theme.spacing(-1.5)
}));

export const SendActionButtonContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(0, 0, 2, 1)
}));
